import { Skeleton, TableCell, TableRow } from '@mui/material';

interface IColunaEsqueleto {
  // Largura do bloco cinza dentro da célula (não da própria coluna) — em %,
  // px ou rem, o que fizer a linha parecer mais próxima do conteúdo real.
  width?: string | number;
  variant?: 'text' | 'rounded' | 'circular';
  height?: number;
  align?: 'left' | 'right' | 'center';
}

interface ILinhasEsqueletoTabelaProps {
  // Quantas linhas fantasma mostrar enquanto carrega — 8 cobre a maioria
  // das listagens sem sobrar espaço vazio nem estourar o container.
  linhas?: number;
  colunas: IColunaEsqueleto[];
}

// Linhas de tabela em formato de esqueleto (blocos cinza pulsando), no lugar
// de um spinner/overlay flutuante — dá pra já enxergar o formato da tabela
// (quantas colunas, alinhamento) enquanto os dados reais ainda não chegaram,
// em vez de esconder tudo atrás de um cartão de carregamento. Cada listagem
// passa a largura/alinhamento aproximado de cada coluna real (ver
// ListagemDeVenda.tsx como referência) pra o esqueleto ficar parecido com o
// resultado final, não genérico demais.
export const LinhasEsqueletoTabela: React.FC<ILinhasEsqueletoTabelaProps> = ({ linhas = 8, colunas }) => (
  <>
    {Array.from({ length: linhas }).map((_, indiceLinha) => (
      <TableRow key={indiceLinha}>
        {colunas.map((coluna, indiceColuna) => (
          <TableCell key={indiceColuna} align={coluna.align}>
            <Skeleton
              variant={coluna.variant ?? 'text'}
              width={coluna.width ?? '70%'}
              height={coluna.height}
              sx={coluna.align === 'right' ? { ml: 'auto' } : undefined}
            />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);
